<cc-top-bar [title]="'ADDRESS_BOOK.LABEL'">
</cc-top-bar>
<router-outlet></router-outlet>
